import * as styledEl from './Collapsible.styled'

export const Collapsible = {
  Root: styledEl.Root,
  Trigger: styledEl.Trigger,
  Panel: styledEl.Panel,
  Chevron: styledEl.Chevron,
}
